import React from "react";
import { createRoot } from "react-dom/client";
import Modal from "react-modal";
import App from "./App";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

Modal.setAppElement("#root");

const container = document.getElementById("root");
const root = createRoot(container);


root.render(
    <React.StrictMode>
        {/* 用 AuthProvider 包裹你的整个应用 */}
        <App />
    </React.StrictMode>
);
